<template>
    <div id="grid_container">
		<div class="flex" id="containerA" @mouseenter="setLetter('design')">
      <!-- <transition name="fade"> -->
			<div v-bar ref="A" class="padding" v-if="currentCategory == 'design' || currentCategory == null" style="width:100%;height:100%;position:absolute">
         <div class="itemcontainer">
				<div class="item" :key="proj.id" v-for="proj in gd_projects.slice().reverse()" @mouseleave=reset() @mouseover=homepageHover(proj) @click=enterProject(proj)> 
					<p v-html="proj.title" v-visible="!insideProject || currentId == proj.id"></p>
				</div>
        </div>
				<div class="item">
					<div class="back" v-show="insideProject && currentCategory == 'design'" @click=exitProject() style="position:fixed;bottom:50px;width:10.5vw;left:18vw;"><img src="uploads/goback-05.png" style="width:100%"></div>
				</div>
			</div>
      <!-- </transition> -->
      
      <transition name="fade">
        <p v-if="currentCategory == 'performance' && !insideProject" class="tags padding" ref="perform_tags" v-text="currentProject.tags"></p>
      </transition>
			
      <div class="img_container" :key="proj.id" v-for="proj in tf_projects">
        <transition name="fade">
				<img :vps_path="vps_path" v-show="currentId == proj.id && !insideProject" :src= "vps_path + proj.preview_image.url"> 
        </transition>
			</div>

                <div class="back" v-show="back_performance_mobile" @click=exitProject() style="position:fixed;bottom:50px;width:10.5vw;left:18vw;"><img src="uploads/goback-05.png" style="width:100%"></div>

			<ProjectImages class="absolute" v-show="insideProject && currentId == proj.id" :key="proj.id" v-for="proj in tf_projects" :project="proj" :vps_path="vps_path"></ProjectImages>

      <ProjectDescription class="absolute" v-show="insideProject && currentCategory == 'performance'" :currentProject="currentProject"></ProjectDescription>
		</div>

		<div class="flex" id="containerB" @mouseenter="setLetter('performance')">
			<div v-bar ref="B" class="padding" v-if="currentCategory == 'performance' || currentCategory == null" style="width:100%;height:100%;position:absolute">
        <transition name="fade">
        <div class="itemcontainer" v-visible="currentCategory == 'performance' || null">
				<div class="item" :key="proj.id" v-for="proj in perform_projects" @mouseleave=reset() @mouseover=homepageHover(proj)> 
					<p id="geenlink" v-html="proj.title" v-visible="!insideProject || currentId == proj.id"></p>
				</div>
				</div>
        </transition>
			</div>

      <transition name="fade">
			<p v-if="currentCategory == 'event' && !insideProject" class="tags padding" ref="event_tags" v-text="currentProject.tags"></p>
      </transition>

			<div class="img_container  blend_img" :key="proj.id" v-for="proj in gd_projects">
        <transition name="fade">
				<img :vps_path="vps_path" v-show="currentId == proj.id && !insideProject" :src= "vps_path + proj.preview_image.url">
        </transition>
			</div>

			<ProjectImages class="absolute" v-show="insideProject && currentId == proj.id" :key="proj.id" v-for="proj in gd_projects" :project="proj" :vps_path="vps_path"></ProjectImages>

			<ProjectDescription class="absolute" v-show="insideProject && currentCategory == 'event'" :currentProject="currentProject"></ProjectDescription>
		</div>

		<div class="flex" id="containerC" @mouseenter="setLetter('event')">
      <!-- <transition name="fade"> -->
			<div v-bar ref="C" class="padding" v-if="currentCategory == 'event' || currentCategory == null" style="width:100%;height:100%;position:absolute">
        <div class="itemcontainer">
				<div class="item" :key="proj.id" v-for="proj in tf_projects.slice().reverse()" @mouseleave=reset() @mouseover=homepageHover(proj) @click=enterProject(proj)> 
					<p v-html="proj.title" v-visible="!insideProject || currentId == proj.id"></p>
				</div>
        </div>
				<div class="item">
				<div class="back" v-show="insideProject && currentCategory == 'event'" @click=exitProject() style="position:fixed;bottom:50px;width:10vw;right:17vw;"><img src="uploads/goback-04.png" style="width:100%"></div>
				</div>
			</div>
      <!-- </transition> -->

      <transition name="fade">
			<p v-if="currentCategory == 'design' && !insideProject" class="tags padding" ref="design_tags" v-text="currentProject.tags"></p>
      </transition>

      <div class="img_container blend_img" :key="proj.id" v-for="proj in perform_projects">
        <transition name="fade">
				<img :vps_path="vps_path" v-show="currentId == proj.id && !insideProject" :src= "vps_path + proj.preview_image.url">
        </transition>
			</div>

        <div id="performance_c" v-if="currentCategory=='performance' && !insideProject">
          <p class="smaller" v-html="currentProject.project_description"></p>
        </div>
          <ProjectDescription class="absolute" v-show="insideProject && currentCategory == 'design'" :currentProject="currentProject"></ProjectDescription>

		</div>

	<img class="letters" v-show="currentLetter == 'design'" @click="lg()" style="left:10vw" src="uploads/LG-02.png">
	<img class="letters" v-show="currentLetter == 'performance'" @click="p()" style="left:48vw" src="uploads/P-02-01.png">
	<img class="letters" v-show="currentLetter == 'event'" @click="tf()" style="left:75vw" src="uploads/TF-02-01.png">
  
    </div>
</template>

<script>
import ProjectImages from './ProjectImages.vue';
import ProjectDescription from './ProjectDescription.vue'
import '../../src/assets/css/leonie_scrollbar.css';

export default {
    name: 'MainGrid',
    components: { 
		ProjectImages, ProjectDescription
	},
	props: ["gd_projects", "perform_projects", "tf_projects"],
	data() {
		return {
      currentId: null,
      currentProject: null,
			currentCategory: null,
      insideProject: false,
      currentLetter: null,
      vps_path: "https://leoniegores.dev0ted.tech",
      back_performance_mobile: false
		}
	},
	methods: {
    setLetter: function(cat) {
      if (!this.insideProject) {
        this.currentLetter = cat;
        this.currentCategory = cat;
        if (this.currentCategory == 'event') {
          this.$emit('darkmode');
        }
        else if (this.currentCategory == 'design') {
          this.$emit('white');
        } else {
          this.$emit('reset');
        }
      }
    },
    setCat: function(catString) {
      this.currentLetter = catString;
    },
		reset: function() {
			if (!this.insideProject) {
				this.currentId = null;
				}
			this.$refs.perform_tags.textContent = "";
			this.$refs.design_tags.textContent = "";
			this.$refs.event_tags.textContent = "";
		},
		homepageHover: function(project) {
			if (!this.insideProject) {
        this.currentLetter = project.categories[0].name;
				window.console.log(project.id + ", " + project.categories[0].name);
				this.currentCategory = project.categories[0].name;
        this.currentId = project.id;
        this.currentProject = project;
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          this.enterProject(project);
          this.back_performance_mobile = true;
          this.currentLetter = project.categories[0].name;
        } 
      }
		},
		enterProject: function(project) {
			if (project.project_images.length != 0){
      this.insideProject = true;
      if (this.currentCategory == 'event') {
        this.$emit('darkmode');
      }
      if (this.currentCategory == 'design') {
        this.$emit('white');
      }
			window.console.log("showproject" + project.id);	
			}
		},
		exitProject: function() {
    this.back_performance_mobile = false;
			if (this.insideProject) {
				this.insideProject = false;
        this.currentId = null;
        this.currentProject = null;
        this.currentCategory = null;
        this.$emit('reset');
      }
		},
		lg: function() {
			this.$emit('update_lg', true);
		},
		p: function() {
			this.$emit('update_p', true);
		},
		tf: function() {
			this.$emit('update_tf', true);
    },
	}
}

</script>

<style>

@keyframes button_filter {
    0% { filter: brightness(100%);}
    50% { filter: brightness(160%) saturate(8) sepia(70%);}
    100% { filter: brightness(100%);}
}

.back img:hover {
  animation: button_filter 2s infinite;
}

.itemcontainer {
  width:100%;
  height:100%;
  position:absolute;
  padding-bottom:25px;
}

.description ul {
  position:relative;
  margin-top:0px;
  font-size:12.5px;
  margin-left:9vw;
}

.description h5 {
  font-size:12.5px;
  position:absolute;
  hyphens: none;
  line-height:1.5;
  margin-left:-9vw;
  /* font-weight: normal; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.absolute {
  position:absolute;
  top:0px;
}

.letters {
	position:fixed;
	cursor: pointer;
	top:32vh;
	height:28%;
}

img.click:hover {
  animation: button_filter 2s infinite;
}

.letters:hover {
  animation: button_filter 2s infinite;
}

.smaller {
	/* font-family: Sporting, sans-serif; */
	font-size:9pt;
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
	line-height:1.3;
}

#grid_container {
  color: #899FAB;
	width:100vw;
  height:100vh;
  overflow:hidden;
	border: solid 10px transparent;
	box-sizing: border-box;
	top:0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	display: flex; 
	flex-direction: row;
}

p
{
line-height:1.5;
}


h6 {
  font-size:12.5px;
  hyphens: none;
  line-height:1.5;
  white-space:pre-line;
}


.item p {
  width:80%;
  font-size:17.5px;
	margin-bottom:20px;
	font-family: Sporting, sans-serif;
}


.item:hover {
	color: #3D76EF;
	cursor:pointer;
}

p#geenlink:hover {
  color:#899FAB;
  cursor:default;
}

.flex {
	position:relative;
	flex: none;
  border-radius: 25px;
  /* box-shadow: inset 0 0 10px lightgrey;  */
  /* background-image: url('/uploads/ocean.png'); */
  /* mix-blend-mode: multiply; */
	box-sizing: border-box;
	width:33.33%;
  /* overflow:hidden; */
  /* background-color:seagreen; */
  animation: foam 35s infinite;
}


.img_container {
	position:absolute;
	width:80%;
	height:74%;
	top:13%; left:10%;
	/* margin: 10%; */
  pointer-events:none;
  
}

.img_container img {
	object-position: 50% 50%;
	object-fit: contain;
	width:100%; 
	height:100%;
  
}

.blend_img {
 opacity: 0.95;
}

.tags {
  font-size:17.5px;
	position:absolute;
  top:0px;
}

.padding {
	padding:28px;
}


#performance_c {
  position:absolute;
  vertical-align: bottom;
  /* line-height:80%; */
  font-size:8px;
  left:28px;
  width:90%;
  bottom:24px;
}

a img {
  height:auto;
  width:10vw;
}

a img:hover {
  opacity:0.7;
}

@media only screen and (max-width: 800px) {
.item p {
  font-size:13px;
  margin-bottom:12px;
}

.tags {
  font-size:13px;
}

h6 {
  font-size:9px;
  font-weight:400;
}

.description h5, .description h6 {
  font-size:9px;
  font-weight:400;
}

.description ul {
  font-size:9px;
  position:relative;
  font-weight:400;
}

.padding {
	padding:20px;
}
}

</style>